export default function RoadmapHeader() {
  return (
    <div className="text-center mb-16">
      <h1 className="text-primary font-kanit text-[48px] leading-[56px] mb-4">Roadmap</h1>
      <p className="text-body-large text-gray-600">
        Our journey to revolutionize real estate investment
      </p>
    </div>
  );
}